import React, { useState, useEffect } from 'react';
import { Star, Phone, Mail, MapPin, Linkedin, Twitter, Award, Users, Heart, Shield, Calendar, Target, ArrowRight } from 'lucide-react';

const Team = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const executiveTeam = [
    {
      name: 'Mukwaya James',
      position: 'Chairperson, Board of Directors',
      image: 'images/mukwaya-james.jpg',
      initials: 'MJ',
      phone: '',
      email: '',
      expertise: [],
      achievements: [],
    },
    {
      name: 'Mukuka Andrews',
      position: 'Director, Fundraising',
      image: 'images/mukuka-andrews.jpeg',
      initials: 'MA',
      phone: '',
      email: '',
      expertise: [],
      achievements: [],
    },
    {
      name: 'Mr. Ssewankambwe Nicholas',
      position: 'Founder & Chief Executive Officer',
      image: 'images/ceo.jpg',
      initials: 'SN',
      phone: '+256 701 816 912',
      email: 'rakaicommunityhealthinitiative@gmail.com',
      expertise: [],
      achievements: [],
    },
    {
      name: 'Dr. Hira Islam',
      position: 'Advisor & Team Lead - TB Control Project',
      image: 'images/hira-aslam.jpeg',
      initials: 'HI',
      phone: '',
      email: '',
      expertise: [],
      achievements: [],
    },
    {
      name: 'Dr. Radhika S Adholeya',
      position: 'Vice Chairman, Board of Directors',
      image: 'images/radhika.jpeg',
      initials: 'RA',
      phone: '',
      email: '',
      expertise: [],
      achievements: [],
    },
    {
      name: 'Dr. Shiv Kumar',
      position: 'Board Member',
      image: 'images/shiv-kumar.jpeg',
      initials: 'SK',
      phone: '',
      email: '',
      expertise: [],
      achievements: [],
    },
  ];

const leadershipTeam = [
  {
    name: 'Prossy Nalubega',
    position: 'Human Resources Manager',
    image: 'images/hr.jpg',

    department: 'Programs'
  },
  {
    name: 'Joseph Wangi',
    position: 'Field Coordinator',
    image: 'images/advocacy.jpg',

    department: 'Operations'
  },
  { 
    name: 'Faith Namukisa',
    position: 'SGBV Officer/Counsellor',
    image: 'images/counsellor.jpg',

    department: 'Support Services'
  }, 
  { 
    name: 'Moses Matovu',
    position: 'Finance & Administration / Treasurer',
    image: 'images/finance.jpg',
    department: 'Support Services'
  }
];


  const advisoryBoard = [
    {
      name: 'Prof. Margaret Nakimuli',
      position: 'Board Chairperson',
      image: 'images/persona.png',
      bio: 'Distinguished professor of Public Health with 25+ years of experience in health policy and women\'s rights advocacy.',
      expertise: ['Health Policy', 'Academic Leadership', 'Women\'s Rights', 'Strategic Governance']
    },
    {
      name: 'Dr. Robert Mayanja',
      position: 'Technical Advisor',
      image: 'images/persona.png',
      bio: 'Former WHO Regional Director with extensive experience in community health programming and SGBV interventions.',
      expertise: ['Global Health', 'SGBV Programming', 'Policy Development', 'International Relations']
    }
  ];

  const teamStats = [
    { number: '8', label: 'Core Team Members', icon: Users },
    { number: '25+', label: 'Years Combined Experience', icon: Award },
    { number: '2,000+', label: 'Lives Impacted', icon: Heart },
    { number: '100%', label: 'Dedicated to the Mission', icon: Target }
  ];

  return (
    <div className="team-page">
      {/* Bootstrap CSS */}
      <link 
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" 
        rel="stylesheet" 
      />

      {/* Decorative Shapes */}
      <div className="decorative-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="shape shape-5"></div>
        <div className="shape shape-6"></div>
      </div>

{/* Hero Section */}
<section className="team-hero">
  <div className="container">
    <div className="row align-items-center min-vh-60">
      <div className="col-lg-8">
        <div className="hero-content">
          <span className="hero-badge">Our Team</span>
          <h1 className="hero-title">
            Meet the Leaders Behind the Change
          </h1>
          <p className="hero-subtitle">
            Our dedicated team of professionals brings together expertise in community health, 
            social work, psychology, and advocacy to create meaningful impact in the fight 
            against Sexual and Gender-Based Violence in Rakai District.
          </p>
          {/* <div className="hero-stats">
            {teamStats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-icon">
                  <stat.icon size={20} />
                </div>
                <div className="stat-content">
                  <span className="stat-number">{stat.number}</span>
                  <span className="stat-label">{stat.label}</span>
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </div>
      <div className="col-lg-4">
        <div className="team-visual">
          <div className="team-shape-container">
            <div className="team-avatars">
              <div className="avatar avatar-1">
                <div className="avatar-inner">👩‍⚕️</div>
              </div>
              <div className="avatar avatar-2">
                <div className="avatar-inner">👨‍💼</div>
              </div>
              <div className="avatar avatar-3">
                <div className="avatar-inner">👩‍🎓</div>
              </div>
              <div className="avatar avatar-4">
                <div className="avatar-inner">👨‍🏫</div>
              </div>
              <div className="avatar avatar-5">
                <div className="avatar-inner">👩‍💻</div>
              </div>
            </div>
            <div className="team-connections">
              <div className="connection connection-1"></div>
              <div className="connection connection-2"></div>
              <div className="connection connection-3"></div>
              <div className="connection connection-4"></div>
            </div>
            <div className="team-network">
              <div className="network-node node-1"></div>
              <div className="network-node node-2"></div>
              <div className="network-node node-3"></div>
              <div className="network-node node-4"></div>
            </div>
            <div className="team-badges">
              <div className="expertise-badge badge-1">
                <span className="badge-icon">🏥</span>
                <span className="badge-text">Health</span>
              </div>
              <div className="expertise-badge badge-2">
                <span className="badge-icon">🧠</span>
                <span className="badge-text">Psychology</span>
              </div>
              <div className="expertise-badge badge-3">
                <span className="badge-icon">⚖️</span>
                <span className="badge-text">Advocacy</span>
              </div>
              <div className="expertise-badge badge-4">
                <span className="badge-icon">🤝</span>
                <span className="badge-text">Social Work</span>
              </div>
            </div>
            <div className="team-energy">
              <div className="energy-pulse pulse-1"></div>
              <div className="energy-pulse pulse-2"></div>
              <div className="energy-pulse pulse-3"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<style jsx>{`
  /* Team Hero Section Enhanced Styles */
//   .team-hero {
//     padding: 2rem 0;
//     background: linear-gradient(135deg, var(--light-gray) 0%, #ffffff 100%);
//     position: relative;
//     overflow: hidden;
//   }

  .team-visual {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 450px;
  }

  .team-shape-container {
    position: relative;
    width: 280px;
    height: 280px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Simple Main Shape */
  .team-avatars {
    position: relative;
    width: 200px;
    height: 200px;
    background: linear-gradient(135deg, var(--primary-blue), var(--accent-teal));
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 20px 60px rgba(37, 99, 235, 0.2);
    animation: teamShapeFloat 6s ease-in-out infinite;
    transform: translateY(-10px);
  }

  .team-avatars::before {
    content: '';
    position: absolute;
    inset: -3px;
    background: linear-gradient(135deg, var(--primary-blue), var(--accent-teal));
    border-radius: 33px;
    z-index: -1;
    opacity: 0.3;
  }

  .avatar {
    position: absolute;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    animation: avatarOrbit 8s linear infinite;
  }

  .avatar-inner {
    font-size: 1.2rem;
  }

  .avatar.avatar-1 {
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    animation-delay: 0s;
  }

  .avatar.avatar-2 {
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    animation-delay: 1.6s;
  }

  .avatar.avatar-3 {
    bottom: 20px;
    right: 35%;
    animation-delay: 3.2s;
  }

  .avatar.avatar-4 {
    bottom: 20px;
    left: 35%;
    animation-delay: 4.8s;
  }

  .avatar.avatar-5 {
    top: 50%;
    left: 20px;
    transform: translateY(-50%);
    animation-delay: 6.4s;
  }

  /* Simple floating elements */
  .team-connections,
  .team-network,
  .team-badges,
  .team-energy {
    display: none;
  }

  /* Animations */
  @keyframes teamShapeFloat {
    0%, 100% {
      transform: translateY(-10px);
    }
    50% {
      transform: translateY(-25px);
    }
  }

  @keyframes avatarOrbit {
    0% {
      transform: translateX(-50%) scale(1);
      opacity: 0.8;
    }
    25% {
      opacity: 1;
    }
    50% {
      transform: translateX(-50%) scale(1.1);
      opacity: 1;
    }
    75% {
      opacity: 1;
    }
    100% {
      transform: translateX(-50%) scale(1);
      opacity: 0.8;
    }
  }

  /* Responsive Design */
  @media (max-width: 992px) {
    .team-visual {
      display: none;
    }
  }

  @media (max-width: 768px) {
    .team-visual {
      display: none;
    }
  }

  /* Accessibility */
  @media (prefers-reduced-motion: reduce) {
    .team-avatars,
    .avatar {
      animation: none;
    }
  }

  /* Enhanced Hover Effects */
  .team-avatars:hover {
    transform: translateY(-15px);
    box-shadow: 0 25px 80px rgba(37, 99, 235, 0.3);
  }

  .team-avatars:hover .avatar {
    animation-duration: 4s;
  }
`}</style>

      {/* Executive Leadership */}
      <section className="executive-section">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Executive Leadership</span>
            <h2 className="section-title">Leading with Vision & Purpose</h2>
          </div>

          <div className="row g-4 justify-content-center">
            {executiveTeam.map((member, index) => (
              <div key={index} className="col-xl-4 col-md-6">
                <div className="exec-card">
                  <div className="exec-image-wrap">
                    {member.image ? (
                      <img 
                        src={member.image} 
                        alt={member.name}
                        className="exec-photo"
                      />
                    ) : (
                      <div className="exec-initials-avatar">
                        <span className="exec-initials">{member.initials}</span>
                      </div>
                    )}
                    <div className="exec-star-badge">
                      <Star size={16} />
                    </div>
                  </div>
                  <div className="exec-body">
                    <h4 className="exec-name">{member.name}</h4>
                    <p className="exec-position">{member.position}</p>
                    {(member.phone || member.email) && (
                      <div className="exec-contact">
                        {member.phone && (
                          <div className="contact-item">
                            <Phone size={14} />
                            <span>{member.phone}</span>
                          </div>
                        )}
                        {member.email && (
                          <div className="contact-item">
                            <Mail size={14} />
                            <span className="contact-email">{member.email}</span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership Team */}
      <section className="leadership-section">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Leadership Team</span>
            <h2 className="section-title">Experienced Professionals</h2>
            <p className="section-description">
              Our multidisciplinary team combines deep expertise with passionate commitment 
              to creating safer communities for women and girls.
            </p>
          </div>

          <div className="row g-4">
            {leadershipTeam.map((member, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div 
                  className="team-card"
                  style={{
                    transform: `translateY(${Math.sin((scrollY + index * 200) * 0.003) * 10}px)`,
                    animationDelay: `${index * 0.1}s`
                  }}
                >
                  <div className="team-card-header">
                    <div className="team-image-container">
                      <img 
                        src={member.image} 
                        alt={member.name}
                        className="team-image"
                      />
                      <div className="team-image-overlay"></div>
                    </div>
                    <div className="department-badge">{member.department}</div>
                  </div>
                  
                  <div className="team-card-content">
                    <h4 className="team-name">{member.name}</h4>
                    <p className="team-position">{member.position}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advisory Board */}
      <section className="advisory-section">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Advisory Board</span>
            <h2 className="section-title">Strategic Guidance</h2>
            <p className="section-description">
              Distinguished leaders providing strategic oversight and technical guidance 
              to ensure our programs achieve maximum impact.
            </p>
          </div>

          <div className="row g-4 justify-content-center">
            {advisoryBoard.map((member, index) => (
              <div key={index} className="col-lg-5 col-md-6">
                <div className="advisor-card">
                  <div className="advisor-header">
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="advisor-image"
                    />
                    <div className="advisor-info">
                      <h4 className="advisor-name">{member.name}</h4>
                      <p className="advisor-position">{member.position}</p>
                    </div>
                  </div>
                  <p className="advisor-bio">{member.bio}</p>
                  <div className="advisor-expertise">
                    {member.expertise.map((skill, idx) => (
                      <span key={idx} className="advisor-skill">{skill}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Custom Styles */}
      <style jsx>{`
        :root {
          --primary-blue: #2563eb;
          --secondary-blue: #1e40af;
          --accent-teal: #06b6d4;
          --accent-orange: #f59e0b;
          --success-green: #10b981;
          --text-gray: #6b7280;
          --light-gray: #f8fafc;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          line-height: 1.6;
          color: #374151;
          padding-top: 80px;
          overflow-x: hidden;
        }

        /* Decorative Shapes */
        .decorative-shapes {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: -1;
        }

        .shape {
          position: absolute;
          border-radius: 50%;
          opacity: 0.05;
          animation: float 20s ease-in-out infinite;
        }

        .shape-1 {
          width: 200px;
          height: 200px;
          background: var(--primary-blue);
          top: 10%;
          right: 10%;
          animation-delay: 0s;
        }

        .shape-2 {
          width: 150px;
          height: 150px;
          background: var(--accent-teal);
          top: 60%;
          left: 5%;
          animation-delay: 5s;
        }

        .shape-3 {
          width: 100px;
          height: 100px;
          background: var(--accent-orange);
          top: 30%;
          left: 15%;
          animation-delay: 10s;
        }

        .shape-4 {
          width: 80px;
          height: 80px;
          background: var(--success-green);
          bottom: 20%;
          right: 20%;
          animation-delay: 15s;
        }

        .shape-5 {
          width: 120px;
          height: 120px;
          background: var(--primary-blue);
          bottom: 40%;
          left: 70%;
          animation-delay: 3s;
        }

        .shape-6 {
          width: 60px;
          height: 60px;
          background: var(--accent-teal);
          top: 80%;
          right: 40%;
          animation-delay: 8s;
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px) rotate(0deg);
          }
          25% {
            transform: translateY(-20px) rotate(90deg);
          }
          50% {
            transform: translateY(-40px) rotate(180deg);
          }
          75% {
            transform: translateY(-20px) rotate(270deg);
          }
        }

        /* Hero Section */
        .team-hero {
          padding: 0rem 0;
          background: linear-gradient(135deg, var(--light-gray) 0%, #ffffff 100%);
          position: relative;
        }

        .min-vh-60 {
          min-height: 60vh;
        }

        .hero-content {
          max-width: 700px;
        }

        .hero-badge {
          background: rgba(37, 99, 235, 0.1);
          color: var(--primary-blue);
          padding: 0.5rem 1.5rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
          display: inline-block;
        }

        .hero-title {
          font-size: clamp(2.5rem, 5vw, 4rem);
          font-weight: 700;
          color: var(--secondary-blue);
          margin-bottom: 1.5rem;
          line-height: 1.1;
        }

        .hero-subtitle {
          font-size: 1.2rem;
          color: var(--text-gray);
          margin-bottom: 0rem;
          line-height: 1.6;
        }

        .hero-stats {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1.5rem;
        }

        .stat-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          background: white;
          padding: 1.5rem;
          border-radius: 1rem;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
        }

        .stat-icon {
          background: var(--primary-blue);
          color: white;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .stat-content {
          display: flex;
          flex-direction: column;
        }

        .stat-number {
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--primary-blue);
          line-height: 1;
        }

        .stat-label {
          font-size: 0.9rem;
          color: var(--text-gray);
          font-weight: 500;
        }

        /* Section Headers */
        .section-header {
          text-align: center;
          margin-bottom: 4rem;
        }

        .section-badge {
          background: rgba(37, 99, 235, 0.1);
          color: var(--primary-blue);
          padding: 0.5rem 1.5rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 600;
          margin-bottom: 1rem;
          display: inline-block;
        }

        .section-title {
          font-size: clamp(2.5rem, 4vw, 3.5rem);
          font-weight: 700;
          color: var(--secondary-blue);
          margin-bottom: 1.5rem;
          line-height: 1.2;
        }

        .section-description {
          font-size: 1.2rem;
          color: var(--text-gray);
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.6;
        }

        /* Executive Section */
        // .executive-section {
        //   padding: 6rem 0;
        // }

        .executive-card {
          background: white;
          border-radius: 2rem;
          padding: 3rem;
          box-shadow: 0 10px 40px rgba(0,0,0,0.1);
          position: relative;
          margin-bottom: 2rem;
        }

        .executive-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 6px;
          background: linear-gradient(90deg, var(--primary-blue), var(--accent-teal), var(--accent-orange));
          border-radius: 2rem 2rem 0 0;
        }

        .executive-image-container {
          position: relative;
          display: inline-block;
        }

        .executive-image {
          width: 250px;
          height: 250px;
          object-fit: cover;
          border-radius: 1.5rem;
          box-shadow: 0 20px 60px rgba(0,0,0,0.15);
        }

        .executive-badge {
          position: absolute;
          top: -10px;
          right: -10px;
          background: var(--accent-orange);
          color: white;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 20px rgba(245, 158, 11, 0.3);
        }

        .image-decoration {
          position: absolute;
          bottom: -15px;
          left: -15px;
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, var(--accent-teal), var(--primary-blue));
          border-radius: 50%;
          opacity: 0.8;
          z-index: -1;
        }

        .executive-content {
          padding-left: 2rem;
        }

        .executive-name {
          font-size: 2.5rem;
          font-weight: 700;
          color: var(--secondary-blue);
          margin-bottom: 0.5rem;
        }

        .executive-position {
          font-size: 1.3rem;
          color: var(--accent-orange);
          font-weight: 600;
          margin-bottom: 1.5rem;
        }

        .executive-bio {
          font-size: 1.1rem;
          color: var(--text-gray);
          margin-bottom: 2rem;
          line-height: 1.6;
        }

        .executive-details {
          margin-bottom: 2rem;
        }

        .detail-title {
          font-weight: 700;
          color: var(--secondary-blue);
          margin-bottom: 1rem;
        }

        .expertise-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }

        .expertise-tag {
          background: rgba(37, 99, 235, 0.1);
          color: var(--primary-blue);
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 500;
        }

        .achievement-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .achievement-list li {
          padding: 0.5rem 0;
          color: var(--text-gray);
          position: relative;
          padding-left: 1.5rem;
        }

        .achievement-list li::before {
          content: '✓';
          color: var(--success-green);
          font-weight: bold;
          position: absolute;
          left: 0;
        }

        .executive-contact {
          display: flex;
          gap: 2rem;
          flex-wrap: wrap;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: var(--text-gray);
        }

        .contact-item svg {
          color: var(--primary-blue);
        }

        .contact-email {
          font-size: 0.9rem;
        }

        /* Leadership Section */
        .leadership-section {
          padding: 6rem 0;
          background: var(--light-gray);
        }

        .team-card {
          background: white;
          border-radius: 1.5rem;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
          transition: all 0.3s ease;
          height: 100%;
          animation: fadeInUp 0.6s ease-out forwards;
          opacity: 0;
        }

        .team-card:hover {
          transform: translateY(-10px) !important;
          box-shadow: 0 25px 80px rgba(0,0,0,0.15);
        }

        .team-card-header {
          position: relative;
        }

        .team-image-container {
          position: relative;
          overflow: hidden;
          aspect-ratio: 3 / 4;
        }

        .team-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
          display: block;
          transition: transform 0.3s ease;
        }

        .team-card:hover .team-image {
          transform: scale(1.05);
        }

        .team-image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(37, 99, 235, 0.1), rgba(6, 182, 212, 0.1));
        }

        .department-badge {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: rgba(255, 255, 255, 0.9);
          color: var(--primary-blue);
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.8rem;
          font-weight: 600;
          backdrop-filter: blur(10px);
        }

        .team-card-content {
          padding: 2rem;
        }

        .team-name {
          font-size: 1.3rem;
          font-weight: 700;
          color: var(--secondary-blue);
          margin-bottom: 0.5rem;
        }

        .team-position {
          color: var(--accent-orange);
          font-weight: 600;
          margin-bottom: 1rem;
        }

        .team-bio {
          color: var(--text-gray);
          font-size: 0.95rem;
          line-height: 1.5;
          margin-bottom: 1.5rem;
        }

        .team-expertise {
          margin-bottom: 1.5rem;
        }

        .expertise-title {
          font-size: 0.9rem;
          font-weight: 700;
          color: var(--secondary-blue);
          margin-bottom: 0.75rem;
        }

        .expertise-pills {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }

        .expertise-pill {
          background: rgba(37, 99, 235, 0.1);
          color: var(--primary-blue);
          padding: 0.25rem 0.75rem;
          border-radius: 50px;
          font-size: 0.8rem;
          font-weight: 500;
        }

        .team-achievements {
          border-top: 1px solid rgba(0,0,0,0.05);
          padding-top: 1rem;
        }

        .achievements-title {
          font-size: 0.9rem;
          font-weight: 700;
          color: var(--secondary-blue);
          margin-bottom: 0.75rem;
        }

        .achievements-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .achievements-list li {
          font-size: 0.85rem;
          color: var(--text-gray);
          margin-bottom: 0.5rem;
          position: relative;
          padding-left: 1rem;
        }

        .achievements-list li::before {
          content: '•';
          color: var(--success-green);
          font-weight: bold;
          position: absolute;
          left: 0;
        }


        /* Executive Cards Grid */
        .exec-card {
          background: white;
          border-radius: 1.5rem;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
          transition: all 0.3s ease;
          height: 100%;
          position: relative;
        }

        .exec-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, var(--primary-blue), var(--accent-teal), var(--accent-orange));
          border-radius: 1.5rem 1.5rem 0 0;
        }

        .exec-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 60px rgba(0,0,0,0.15);
        }

        .exec-image-wrap {
          position: relative;
          overflow: hidden;
          aspect-ratio: 3 / 4;
        }

        .exec-photo {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
          display: block;
          transition: transform 0.3s ease;
        }

        .exec-card:hover .exec-photo {
          transform: scale(1.05);
        }

        .exec-initials-avatar {
          width: 100%;
          aspect-ratio: 3 / 4;
          background: linear-gradient(135deg, var(--primary-blue), var(--accent-teal));
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .exec-initials {
          font-size: 4rem;
          font-weight: 700;
          color: white;
          letter-spacing: 2px;
          opacity: 0.9;
        }

        .exec-star-badge {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: var(--accent-orange);
          color: white;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);
        }

        .exec-body {
          padding: 1.5rem;
          text-align: center;
        }

        .exec-name {
          font-size: 1.2rem;
          font-weight: 700;
          color: var(--secondary-blue);
          margin-bottom: 0.4rem;
        }

        .exec-position {
          color: var(--accent-orange);
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 1rem;
          line-height: 1.4;
        }

        .exec-contact {
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
          align-items: center;
          border-top: 1px solid rgba(0,0,0,0.06);
          padding-top: 1rem;
        }

        .exec-contact .contact-item {
          font-size: 0.82rem;
          justify-content: center;
        }

        /* Advisory Section */
        .advisory-section {
          padding: 6rem 0;
        }

        .advisor-card {
          background: white;
          border-radius: 1.5rem;
          padding: 2.5rem;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
          height: 100%;
          transition: all 0.3s ease;
        }

        .advisor-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 60px rgba(0,0,0,0.15);
        }

        .advisor-header {
          display: flex;
          align-items: center;
          gap: 1.5rem;
          margin-bottom: 1.5rem;
        }

        .advisor-image {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          object-fit: cover;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
        }

        .advisor-name {
          font-size: 1.3rem;
          font-weight: 700;
          color: var(--secondary-blue);
          margin-bottom: 0.25rem;
        }

        .advisor-position {
          color: var(--accent-orange);
          font-weight: 600;
          margin: 0;
        }

        .advisor-bio {
          color: var(--text-gray);
          line-height: 1.6;
          margin-bottom: 1.5rem;
        }

        .advisor-expertise {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }

        .advisor-skill {
          background: rgba(6, 182, 212, 0.1);
          color: var(--accent-teal);
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 500;
        }

        /* Join Team Section */
        .join-team-section {
          padding: 6rem 0;
          background: linear-gradient(135deg, var(--secondary-blue), var(--primary-blue));
          color: white;
          position: relative;
        }

        .join-team-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="2" fill="rgba(255,255,255,0.1)"/></svg>') repeat;
          background-size: 50px 50px;
        }

        .join-title {
          font-size: clamp(2.5rem, 4vw, 3.5rem);
          font-weight: 700;
          margin-bottom: 1.5rem;
          line-height: 1.2;
          position: relative;
        }

        .join-description {
          font-size: 1.2rem;
          margin-bottom: 3rem;
          opacity: 0.9;
          line-height: 1.6;
          position: relative;
        }

        .join-buttons {
          display: flex;
          gap: 1rem;
          justify-content: center;
          flex-wrap: wrap;
          position: relative;
        }

        .join-buttons .btn {
          padding: 1rem 2.5rem;
          border-radius: 50px;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .join-buttons .btn:hover {
          transform: translateY(-2px);
        }

        /* Button Styles */
        .btn-primary {
          background-color: var(--primary-blue);
          border-color: var(--primary-blue);
        }

        .btn-primary:hover {
          background-color: var(--secondary-blue);
          border-color: var(--secondary-blue);
        }

        .btn-warning {
          background-color: var(--accent-orange);
          border-color: var(--accent-orange);
          color: white;
        }

        .btn-warning:hover {
          background-color: #d97706;
          border-color: #d97706;
          color: white;
        }

        /* Animations */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          body {
            padding-top: 70px;
          }

          .decorative-shapes {
            display: none;
          }
          
          .hero-stats {
            grid-template-columns: 1fr;
          }
          
          .stat-item {
            justify-content: center;
            text-align: center;
          }
          
          .executive-content {
            padding-left: 0;
            margin-top: 2rem;
          }
          
          .executive-image {
            width: 200px;
            height: 200px;
            margin: 0 auto;
            display: block;
          }
          
          .executive-contact {
            flex-direction: column;
            gap: 1rem;
          }
          
          .advisor-header {
            flex-direction: column;
            text-align: center;
          }
          
          .join-buttons {
            flex-direction: column;
            align-items: center;
          }
          
          .join-buttons .btn {
            width: 100%;
            max-width: 300px;
          }
        }

        @media (max-width: 576px) {
          .executive-card {
            padding: 2rem 1.5rem;
          }
          
          .team-card-content {
            padding: 1.5rem;
          }
          
          .advisor-card {
            padding: 2rem 1.5rem;
          }
          
          .expertise-tags {
            justify-content: center;
          }
          
          .expertise-pills {
            justify-content: center;
          }
          
          .advisor-expertise {
            justify-content: center;
          }
        }

        /* Print Styles */
        @media print {
          .decorative-shapes {
            display: none;
          }
          
          .join-team-section {
            background: var(--light-gray) !important;
            color: var(--text-gray) !important;
          }
        }

        /* Accessibility Improvements */
        .btn:focus,
        .team-card:focus,
        .advisor-card:focus {
          outline: 2px solid var(--accent-orange);
          outline-offset: 2px;
        }

        /* Smooth Scrolling */
        html {
          scroll-behavior: smooth;
        }

        /* Loading States */
        .team-card,
        .advisor-card {
          animation-fill-mode: both;
        }

        /* Additional Visual Enhancements */
        .executive-card::after {
          content: '';
          position: absolute;
          bottom: -10px;
          right: -10px;
          width: 100px;
          height: 100px;
          background: linear-gradient(135deg, var(--accent-teal), var(--accent-orange));
          border-radius: 50%;
          opacity: 0.1;
          z-index: -1;
        }

        .team-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, var(--primary-blue), var(--accent-teal));
          border-radius: 1.5rem 1.5rem 0 0;
        }

        .advisor-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, var(--accent-orange), var(--success-green));
          border-radius: 1.5rem 1.5rem 0 0;
        }

        /* Hover Effects for Interactive Elements */
        .expertise-tag:hover,
        .expertise-pill:hover,
        .advisor-skill:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(0,0,0,0.1);
        }

        /* Custom Scrollbar */
        ::-webkit-scrollbar {
          width: 8px;
        }

        ::-webkit-scrollbar-track {
          background: var(--light-gray);
        }

        ::-webkit-scrollbar-thumb {
          background: var(--primary-blue);
          border-radius: 4px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: var(--secondary-blue);
        }
      `}</style>

      {/* Bootstrap JS */}
      <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js"></script>
    </div>
  );
};

export default Team;
